import type { SerializedError } from '@reduxjs/toolkit';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query/react';

export const isNotFoundError = (
  requestError?: FetchBaseQueryError | SerializedError,
) => {
  const status =
    requestError && 'status' in requestError ? requestError.status : undefined;
  return status === 404;
};
